import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const defaults = {
  apiKey: 'AIzaSyCPnfIA_vHrNSXSWpX_qPyVuM4GAOKeJEM',
  authDomain: 'area-network-app.firebaseapp.com',
  projectId: 'area-network-app',
  storageBucket: 'area-network-app.firebasestorage.app',
  messagingSenderId: '275425884338',
  appId: '1:275425884338:web:0876d74deee428c3b731ab',
  measurementId: 'G-CBCG0WWQEL',
};

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || defaults.apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || defaults.authDomain,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || defaults.projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || defaults.storageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || defaults.messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_APP_ID || defaults.appId,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || defaults.measurementId,
};

export const firebaseApp = initializeApp(config);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');
setPersistence(auth, browserLocalPersistence).catch(console.error);
